<template>
    <div class="pt-3 integration-mapping">
        <v-form
            v-if="items"
            ref="form"
            class="p-3 pt-0"
            @submit="onSubmit"
            :disabled="is_view">
            <v-container fluid>
                <v-row>
                    <v-col class="overflow-auto">
                        <table class="table table-hover table-fs">
                            <thead>
                                <tr>
                                    <th width="200">Consignment Status</th>
                                    <th>Record Status</th>
                                    <th width="200">Update Source</th>
                                </tr>
                            </thead>
                            <tbody v-if="allitems.length > 0">
                                <tr v-for="(item, index) in allitems" :key="'status-mapping-' + index">
                                    <td>{{ item.machship_status }}</td>
                                    <td>
                                        <v-select
                                            dense
                                            outlined
                                            :full-width="false"
                                            :disabled="is_view"
                                            :items="statusList"
                                            v-model="item.record_status"
                                        ></v-select>
                                    </td>
                                    <td>
                                        <v-checkbox
                                            class="mx-auto"
                                            v-model="item.update_source"
                                            :disabled="is_view">
                                        </v-checkbox>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td colspan="3">
                                        <p>No machship status mappings</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </v-col>
                </v-row>
                <v-row v-if="!is_view && items.length > 0">
                    <v-col class="text-right">
                        <v-btn type="submit" small class="mr-1" color="primary" :disabled="isSubmit">
                            <span v-if="isSubmit">
                                <v-progress-circular
                                    indeterminate
                                    size="12"
                                    width="2"
                                    color="green darken-3">
                                </v-progress-circular>
                                Updating..
                            </span>
                            <span v-else>Update</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
        <v-progress-linear
            v-else
            indeterminate
            color="primary"
            class="mb-5">
        </v-progress-linear>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus.js'

export default {
    props: {
        // integration id
        id: { type: Number, default: null },
        is_view: { type: Boolean, default: false }
    },
    data() {
        return {
            items: null,
            isSubmit: false,
            statusList: [],
            machshipStatus: []
        }
    },
    created() {
        this.fetchStatusList()
        this.fetchStatusMapping()
    },

    computed: {
        allitems() {
            const all = this.items

            // if this is for view show only saved items
            if (this.is_view) {
                return all
            }

            // if not, we need to show everything thru here
            Object.keys(this.machshipStatus).forEach(status => {
                let item = this.items.find(item => item.machship_status == status)
                // if not found then we need to add this
                if (!item) {
                    all.push({
                        integration_id: this.id,
                        machship_status_id: this.machshipStatus[status],
                        machship_status: status
                    })
                }
            })

            return all
        }
    },

    methods: {


        fetchStatusList() {
            this.$http
                .get('api/status/mapping/options')
                .then(({ data }) => {
                    this.statusList = data.record_status.map(item => {
                        return {
                            text: item,
                            value: item
                        }
                    })
                    this.statusList.unshift({text: '', value: null})
                    this.machshipStatus = data.machship_status
                })
        },

        fetchStatusMapping() {
            if (!this.id) {
                EventBus.$emit('show-error', 'Invalid integration id')
                return
            }

            this.$http
                .get('api/status/mapping', {
                    params: {
                        integration_id: this.id,
                        limit: -1
                    }
                })
                .then(({ data }) => {

                    this.items = data.data.map(item => {
                        let obj = item.attributes
                        obj.id = item.id
                        return obj
                    })
                })
        },

        onSubmit(e) {
            e.preventDefault()
            this.isSubmit = true
            this.$http
                .post('api/status/mapping/bulk', this.items)
                .then(({ data }) => {
                    this.isSubmit = false
                    this.fetchStatusMapping()
                    EventBus.$emit('show-success', 'Successfully updated status mapper')
                })
                .catch(err => {
                    EventBus.$emit('show-error', err)
                    this.isSubmit = false
                    this.fetchStatusMapping()
                })
        }
    }
}
</script>